module.exports = __webpack_public_path__ + "img/imginspo2.e3534bce.png";